exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".vegaRenderer {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.vegaRenderer a {\r\n  text-decoration: none;\r\n  color: #888;\r\n  margin-right: 0.5rem;\r\n}\r\n.vegaRenderer a:hover {\r\n  color: steelblue;\r\n}", ""]);

// exports
